import { render } from "./MobileCartTableRow.vue?vue&type=template&id=2cfafc3b&scoped=true"
import script from "./MobileCartTableRow.vue?vue&type=script&lang=js"
export * from "./MobileCartTableRow.vue?vue&type=script&lang=js"

import "./MobileCartTableRow.vue?vue&type=style&index=0&id=2cfafc3b&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/sb.web.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cfafc3b"]])

export default __exports__